// ==== Custom function for curve-analysis chart=======================================================
import { select, event } from "d3";
import { bandsCreate, hLineCreate } from "@/_core/charts/D3ChartHoverHelpers";
// import { textinactive } from "@/_core/_helpers/_parametric_tools";

/**
 * Create hover function "class"
 */
export const D3HoverCurveAnalysis = function(
  containerHistorical,
  containerFutures,
  uniqueId,
) {
  this.containerHistorical = `${containerHistorical}-div`;
  this.containerFutures = `${containerFutures}-div`;
  this.uniqueId = uniqueId;
};

/**
 * Create hover function, tooltips, etc.
 * @param {object} _this: context variables
 * @param {object} svg: svg node for chart
 * @param {string} svgField: svg NAME for chart
 * @param {string} customName: customName cor items
 * @param {function} formatNumber: function to format y values
 * @param {function} dateFormat: function to format x values
 * @param {boolean} colorTheme: dark = true, light = false
 * @param {double} valueLast: latest y value to fix
 * @param {color} colorLast: background color of fixed last value div
 * @param {color} colorY: background color of hovered y value
 * @param {color} colorX: background color of hovered date
 * @param {integer} xTooltipWidth: x tooltip width in px
 * @param {integer} yTooltipWidth: y tooltip width in px
 * @param {color} hoveredLines: x-y hovered lines color
 * @param {boolean} isLeft: chart is left = true/null or right=false
 * @param {boolean} showComparison: show comparison mode
 * @param {string} uniqueId: unique identifier for this instance
 */
D3HoverCurveAnalysis.prototype.hoverFct = function(
  _this,
  svg,
  svgField,
  customName,
  formatNumber,
  dateFormat,
  colorTheme,
  valueLast,
  colorLast,
  colorY,
  colorX,
  xTooltipWidth,
  yTooltipWidth,
  hoveredLines,
  isLeft = true,
  showComparison,
) {
  let context = this;
  // let sharp = "#";
  let messageTooltip;
  // let txt = "";
  if (isLeft && showComparison) {
    // txt =
    //   "<table class='table table-borderless table-sm text-left table-analytics-sm'>\n" +
    //   "  <tbody>\n" +
    //   "    <tr>\n" +
    //   "      <td>Click to select Date</td>\n" +
    //   "    </tr>\n" +
    //   "  </tbody>\n" +
    //   "</table>";
    messageTooltip = null;
    // select(`${sharp}${svg.parentElement}`)
    //   .append("div")
    //   .style("opacity", 0)
    //   .style("margin", "0 auto")
    //   .style("text-align", "right")
    //   .style("background", "rgba(0,0,0,0)")
    //   .style("border", colorY)
    //   .style("color", textinactive(colorTheme))
    //   .style("padding", "2px")
    //   .attr("class", `tooltip-${this.uniqueId}`)
    //   .style("font-size", "0.8rem")
    //   .style("width", "130px")
    //   .style("right", svg.margin.right + "px")
    //   .style("bottom", svg.margin.bottom + "px")
    //   .html(txt);
  }

  const selectIsHoved = (customNames, i, isHoved) => {
    const container = isLeft
      ? `#${this.containerHistorical}`
      : `#${this.containerFutures}`;

    customNames.forEach((className) => {
      select(`${container} .${className}${i}`).classed("hoved", isHoved);
    });
  };

  const mouseOver = function(d, i) {
    context.mouseOverF(
      d,
      i,
      _this,
      svg,
      svgField,
      isLeft,
      selectIsHoved,
      formatNumber,
      messageTooltip,
      xTooltipWidth,
      dateFormat,
      showComparison,
    );
  };

  const mClick = function(d, i) {
    if (showComparison) {
      context.mClickF(d, i, _this);
    }
  };

  const mouseLeave = function(d) {
    context.mouseLeaveF(
      d,
      _this,
      svg,
      svgField,
      isLeft,
      messageTooltip,
      showComparison,
    );
  };

  hLineCreate(svg, customName, hoveredLines, 1);
  bandsCreate(
    isLeft ? _this.allData["historicalSliced"] : _this.allData["futuresCurve"],
    svg,
    customName,
    mouseOver,
    mouseLeave,
    mouseOver,
    true,
    "id",
    mClick,
  );
};

D3HoverCurveAnalysis.prototype.mouseOverF = function(
  d,
  i,
  _this,
  svg,
  svgField,
  isLeft,
  selectIsHoved,
  formatNumber,
  messageTooltip,
  xTooltipWidth,
  dateFormat,
  showComparison,
) {
  event.preventDefault();
  const yPixels = Math.max(
    Math.min(event.layerY - svg.margin.top, svg.height),
    0,
  );
  if (isLeft && showComparison) {
    _this.animateCurveChart(d, i);
  }

  select(`#${this.containerHistorical} .hHoverLineTA`)
    .style("opacity", 1)
    .attr("y1", yPixels)
    .attr("y2", yPixels);
  // === rates chart
  select(`#${this.containerFutures} .hHoverLineRATES`)
    .style("opacity", 1)
    .attr("y1", yPixels)
    .attr("y2", yPixels);

  let customNames = isLeft
    ? ["bandsTA", "candleTA"]
    : [
        "bandsRATES",
        "barRATEAVE",
        "barRATEMAX",
        "barRATEMIN",
        "barRATECURRENT",
        "barRATEHISTORICAL",
      ];
  selectIsHoved(customNames, d.id, true);

  let pos = isLeft ? "right" : "left";
  let posPixels = isLeft
    ? svg.width + svg.margin.right + 2 + "px"
    : svg.width + svg.margin.left + 2 + "px";
  _this.chartElements[svgField]["yTooltip"]
    .style("opacity", 1)
    .style(pos, posPixels)
    .style("top", yPixels + svg.margin.top - 9 + "px")
    .html(formatNumber(svg.y.invert(yPixels)));

  // if (isLeft && showComparison) {
  //   messageTooltip.style("opacity", 1);
  // }

  _this.chartElements[svgField]["xTooltip"]
    .style("opacity", 1)
    .style(
      "left",
      svg.x(d.date) +
        svg.x.bandwidth() / 2 +
        svg.margin.left -
        xTooltipWidth / 2 +
        "px",
    )
    .html(dateFormat(d.date));

  Object.assign(_this.formatVars, {
    userHovered: {
      date: d.id,
      variable: "",
      hovered: false,
      fromChart: true,
    },
  });
};

D3HoverCurveAnalysis.prototype.mClickF = function(d, i, _this) {
  Object.assign(_this.userSelections, { dateInterval: "..." });
  Object.assign(_this.allData, { highlight: true });
  setTimeout(() => {
    Object.assign(_this.allData, { highlight: false });
  }, 1000);
  Object.assign(_this.userSelections, {
    prevSelectedDateIdx:
      _this.allData["historical"].length -
      _this.allData["historicalSliced"].length +
      i,
  });
  _this.animateDiamond();
};

D3HoverCurveAnalysis.prototype.mouseLeaveF = function(
  d,
  _this,
  svg,
  svgField,
  isLeft,
  messageTooltip,
  showComparison,
) {
  let dat =
    _this.allData["historical"][_this.userSelections["prevSelectedDateIdx"]];
  let idx =
    _this.userSelections["prevSelectedDateIdx"] -
    _this.allData["historical"].length +
    _this.allData["historicalSliced"].length;
  if (isLeft && showComparison) {
    _this.animateCurveChart(dat, idx);
  }

  select(`#${this.containerHistorical} .hHoverLineTA`)
    .style("opacity", 0)
    .attr("display", null);
  // === rates chart
  select(`#${this.containerFutures} .hHoverLineRATES`)
    .style("opacity", 0)
    .attr("display", null);

  let pos = isLeft ? "right" : "left";
  _this.chartElements[svgField]["yTooltip"]
    .style(pos, "-1000000px")
    .style("top", "0px")
    .style("opacity", 0)
    .html("");
  _this.chartElements[svgField]["xTooltip"]
    .style("left", "-1000000px")
    .style("opacity", 0)
    .html("");
  // if (isLeft && showComparison) {
  //   messageTooltip.style("opacity", 0);
  // }

  select(`#${this.containerHistorical} .candleTA${d.id}`).classed(
    "hoved",
    false,
  );
  select(`#${this.containerHistorical} .bandsTA${d.id}`).classed(
    "hoved",
    false,
  );
  // === for rates
  select(`#${this.containerFutures} .bandsRATES${d.id}`).classed(
    "hoved",
    false,
  );
  select(`#${this.containerFutures} .barRATEAVE${d.id}`).classed(
    "hoved",
    false,
  );
  select(`#${this.containerFutures} .barRATEMAX${d.id}`).classed(
    "hoved",
    false,
  );
  select(`#${this.containerFutures} .barRATEMIN${d.id}`).classed(
    "hoved",
    false,
  );
  select(`#${this.containerFutures} .barRATECURRENT${d.id}`).classed(
    "hoved",
    false,
  );
  select(`#${this.containerFutures} .barRATEHISTORICAL${d.id}`).classed(
    "hoved",
    false,
  );

  Object.assign(_this.formatVars, {
    userHovered: {
      date: d.id,
      variable: "",
      hovered: false,
      fromChart: false,
    },
  });
};
